import { render, staticRenderFns } from "./StartseiteRaeumeTermine.vue?vue&type=template&id=206e09f4&"
import script from "./StartseiteRaeumeTermine.vue?vue&type=script&lang=js&"
export * from "./StartseiteRaeumeTermine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports